<template>
  <div v-if="!isAuthenticated" class="menu-items">
    <div class="menu-group">
      <MenuItem
        :href="$routes.HELP"
        icon-class="help"
        :title="$t('menu_items_link_5')"
      />
      <MenuItem
        :external="!$country.isFeatureEnabled('SEARCH')"
        :href="$routes.SEARCH"
        icon-class="search"
        :title="$t('menu_items_link_4')"
      />
      <MenuItem
        v-if="$country.isFeatureEnabled('SWAP_APPLICATION')"
        :external="true"
        :href="$routes.SWAP_APPLICATION"
        icon-class="contract"
        :title="$t('menu_items_link_7')"
      />
      <MenuItem
        :href="$routes.LOGIN"
        icon-class="login"
        :title="$t('menu_items_link_8')"
      />
    </div>

    <div class="menu-bottom-wrapper">
      <div>
        <a :href="$routes.GENERAL_TERMS">{{ $t('menu_items_link_10') }}</a>
        <a :href="$routes.PRIVACY_POLICY">{{ $t('menu_items_link_14') }}</a>
        <a :href="$routes.COOKIE_POLICY">{{ $t('menu_items_link_11') }}</a>
      </div>
    </div>
  </div>

  <!-- Like the app's menu: three cards. Listings (blue icon tiles), help and
       news (grey), and Log out on its own. "Hjälp och feedback" leads to the
       help page, which also has the feedback forms. Mitt konto is the profile card
       above; blocked listings are on the Mitt konto page. -->
  <div v-else class="menu-items">
    <div class="menu-group">
      <MenuItem
        :href="$routes.FAVOURITES"
        tone="primary"
        icon-class="heart"
        :title="$t('popup_menu_item_4')"
      />
      <MenuItem
        v-if="$country.isFeatureEnabled('SWAP_APPLICATION')"
        :external="true"
        :href="$routes.SWAP_APPLICATION"
        tone="primary"
        icon-class="contract"
        :title="$t('popup_menu_item_6')"
      />
      <MenuItem
        :href="$routes.SEARCH"
        tone="primary"
        icon-class="search"
        :title="$t('popup_menu_item_5')"
      />
      <MenuItem
        v-if="$country.isFeatureEnabled('PAYMENT') && primaryPropositionId"
        :href="`${$t(
          'path_handle_subscription',
          $routeLocale
        )}/${primaryPropositionId}`"
        tone="primary"
        icon-class="wallet"
        :title="$t('my_propositions_link_payments')"
      />
    </div>

    <div class="menu-group">
      <MenuItem
        :href="$routes.HELP"
        icon-class="help"
        :title="$t('popup_menu_item_7')"
      />
      <MenuItem
        :href="$routes.NEWS"
        icon-class="lightbulb"
        :title="$t('the_footer_news')"
      />
    </div>

    <div class="menu-group">
      <MenuItem
        :href="$routes.LOGOUT"
        icon-class="logout"
        :title="$t('popup_menu_item_8')"
      />
    </div>

    <ImpersonateBanner v-if="isImpersonated && isMobile"></ImpersonateBanner>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MenuItem from './MenuItem';
import ImpersonateBanner from '@/components/Banners/ImpersonateBanner.vue';

export default {
  name: 'MenuItems',
  components: {
    MenuItem,
    ImpersonateBanner
  },

  computed: {
    ...mapGetters({
      isMobile: 'screenSize/isMobile',
      isAuthenticated: 'app/isAuthenticated',
      isImpersonated: 'app/isImpersonated',
      notifications: 'menu/getNotifications',
      primaryPropositionId: 'myPropositions/primaryPropositionId'
    })
  }
};
</script>

<style lang="scss" scoped>
.menu-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
  padding: 12px;
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background-color: var(--Surface-Subtle);
}

// White card with rounded corners, like the app.
.menu-group {
  flex-shrink: 0;
  overflow: hidden;
  border-radius: $card-radius;
  background-color: var(--Surface-White);
}

.menu-bottom-wrapper {
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.menu-bottom-wrapper > div {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #eee;
  font-weight: 600;
  font-size: 12px;
}

.menu-bottom-wrapper > div > a {
  text-decoration: none;
  color: var(--Text-Primary);
}
</style>
